exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".invoice-modal .sweet-modal.is-alert .sweet-content{padding:24px}.invoice-modal .invoice-modal-title{font-size:22px;font-weight:700;margin-bottom:24px}", ""]);

// exports
